module.exports = __webpack_public_path__ + "img/25.a3d1f0d1.svg";